import React, { useState, useEffect } from 'react';
import { Button, Card, Form, Modal, Row, Col } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';

import Layout from '../../layout/default';
import Block from '../../components/Block/Block';
import DataTable from '../../components/DataTable/DataTable';
import { Icon } from "../../components"
import { userColumns } from "../../store/states/StatesData"
import instance from "../api"

function StatesList() {
    const { zone_id } = useParams();

    // NEW CODE
  const [ searchText, setSearchText ] = useState("")
  // NEW CODE ENDS

    const [showModal, setShowModal] = useState(false);
    const [statesData, setStatesData] = useState([]);
    const [countriesData, setCountriesData] = useState([]);
    const [countryId, setCountryId] = useState('');
    const [stateName, setStateName] = useState('');
    const [stateCode, setStateCode] = useState('');
    const [editingState, setEditingState] = useState(null);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalCount, setTotalCount] = useState(0);
    const [fieldErrors, setFieldErrors] = useState({
        countryId: false,
        stateName: false,
    });

    const handleShowModal = () => setShowModal(true);

    const handleCloseModal = () => {
        setShowModal(false);
        resetForm();
    };

    const resetForm = () => {
        setCountryId('');
        setStateName('');
        setStateCode('');
        setEditingState(null);
        setFieldErrors({
            countryId: false,
            stateName: false,
            stateCode: false
        });
    };

    const validateForm = () => {
        const errors = {};

        if (!countryId) errors.countryId = true;
        if (!stateName) errors.stateName = true;

        setFieldErrors(errors);

        return Object.values(errors).every(error => !error);
    };

    const fetchData = async (page, pageSize) => {
        try {
            const countriesResponse = await instance.get('api/Master/Country', {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json; charset=utf-8',
                   'ngrok-skip-browser-warning':'true',
                }
            });
            setCountriesData(countriesResponse.data.rows);
            
            const queryParams = `pageSize=${pageSize}&page=${page}` + 
                      (searchText ? `&search=${searchText}` : '');
      

            // const statesResponse = await instance.get(`api/Master/Zone?pageSize=${pageSize}&page=${page}`);
            const statesResponse = await instance.get(`api/Master/Zone?${queryParams}`);
            setStatesData(statesResponse.data.rows);
            setTotalCount(statesResponse.data.count);

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchStateDetails = async () => {
        try {
            const response = await instance.get(`api/Master/Zone/${zone_id}`, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json; charset=utf-8',
                   'ngrok-skip-browser-warning':'true',
                }
            });
            const state = response.data;
            setCountryId(state.country_id || '');
            setStateName(state.name || '');
            setStateCode(state.code || '');
           
            setEditingState(state);
            handleShowModal();
        } catch (error) {
            console.error('Error fetching Country details:', error);
        }
    };
    const postData = async () => {
        if (!validateForm()) return;

        try {
            const payload = {
                country_id: countryId,
                name: stateName,
                code: stateCode
            };

            let response;
            if (editingState) {
                response = await instance.put(`api/Master/Zone/update/${editingState.zone_id}`, payload);
            } else {
                response = await instance.post('api/Master/Zone/create', payload);
            }

            // console.log('State response:', response.data);
            handleCloseModal();
            fetchData();
            Swal.fire('Success', 'State updated successfully!', 'success');
        } catch (error) {
            console.error('Error:', error);
            Swal.fire('Error', 'Failed to update State!', 'error');
        }
    };

    useEffect(() => {
        fetchData(page, rowsPerPage);
        if (zone_id) {
            fetchStateDetails();
        }
    }, [ zone_id, page, rowsPerPage, searchText ]);
    
     // NEW CODE
    const handleSearchTextChange = (text) => {
    setSearchText(text);
    };
// NEW CODE ENDS

    const handleChangePage = (_event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        const newSize = parseInt(event.target.value, 10);
        setRowsPerPage(newSize);
        setPage(0);
    };
    useEffect(() => {
        fetchData(page, rowsPerPage);
    }, [page, rowsPerPage]);

    const stateColumns = userColumns({ setStatesData });

    return (
        <Layout title="States List" content="container">
            <Block.Head>
                <Block.HeadBetween>
                    <Block.HeadContent>
                        <Block.Title tag="h2">States List</Block.Title>
                        {/* <nav>
                            <ol className="breadcrumb breadcrumb-arrow mb-0">
                                <li className="breadcrumb-item"><Link to="/home-ecommerce">Home</Link></li>
                                <li className="breadcrumb-item"><Link to="">States Manage</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">States</li>
                            </ol>
                        </nav> */}
                    </Block.HeadContent>
                    <Block.HeadContent>
                        <ul className="d-flex">
                            <li>
                                <Button className="d-none d-md-inline-flex" variant="primary" onClick={handleShowModal}>
                                    <Icon name="plus" />
                                    <span>Add State</span>
                                </Button>
                            </li>
                        </ul>
                    </Block.HeadContent>
                </Block.HeadBetween>
            </Block.Head>

            <Block>
                <Card>
                    <DataTable
                        tableClassName="data-table-head-light table-responsive"
                        data={statesData}
                        columns={stateColumns}
                        searchList={['name', 'WebtagCountry.name']}
                        searchTerm="State Name"
                        // searchTerm="State Name,Country"
                        totalCount={totalCount}
                        page={page}
                        rowsPerPage={rowsPerPage}
                        onChangePage={handleChangePage}
                        onChangeRowsPerPage={handleChangeRowsPerPage} 
                        // NEW ONE 
            onSearchTextChange={handleSearchTextChange}
            // NEW ONE ENDS
                        />
                        
               
                </Card>
            </Block>

            <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>{editingState ? 'Edit State' : 'Add State'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Row>
                            <Col>
                                <Form.Group controlId="formCountry">
                                    <Form.Label>Select Country</Form.Label>
                                    <Form.Control as="select" onChange={(e) => setCountryId(e.target.value)} value={countryId}  className={fieldErrors.countryId ? 'is-invalid' : ''}>
                                        <option value="">Select</option>
                                        
                                        {countriesData.map(country => (
                                            <option key={country.country_id} value={country.country_id}>{country.name}</option>
                                        ))}
                                                                          
 
                                    </Form.Control>
                                    {fieldErrors.countryId && <div className="invalid-feedback">Please select a country.</div>}
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group controlId="formStateName">
                                    <Form.Label>State Name</Form.Label>
                                    <Form.Control type="text" placeholder="Enter state name" value={stateName} onChange={(e) => setStateName(e.target.value)}
                                    className={fieldErrors.stateName ? 'is-invalid' : ''}
/>
                                    {fieldErrors.stateName && <div className="invalid-feedback">Please enter a state name.</div>}
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group controlId="formStateCode">
                                    <Form.Label>State Code</Form.Label>
                                    <Form.Control type="text" placeholder="Enter state code" value={stateCode} onChange={(e) => setStateCode(e.target.value)}
                                     className={fieldErrors.stateCode ? 'is-invalid' : ''}/>

                                    {/* {fieldErrors.stateCode && <div className="invalid-feedback">Please enter a state code.</div>} */}
                                </Form.Group>
                            </Col>
                        </Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>Close</Button>
                    <Button variant="primary" onClick={postData}>{editingState ? 'Update State' : 'Add State'}</Button>
                </Modal.Footer>
            </Modal>
        </Layout>
    );
}
export const handleDeleteState = async (zone_id, setStatesData) => {
    const confirmed = window.confirm('Are you sure you want to delete this State?');
    if (confirmed) {
        try {
            await instance.delete(`api/Master/Zone/delete/${zone_id}`,{
            headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json; charset=utf-8',
                   'ngrok-skip-browser-warning':'true',
                }
            });
            // console.log(`State with ID ${zone_id} deleted successfully.`);
            Swal.fire("Success", "State deleted successfully!", "success");

            const updatedResponse = await instance.get('api/Master/Zone?pageSize=100000', {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json; charset=utf-8',
                   'ngrok-skip-browser-warning':'true',
                }
            });
            setStatesData(updatedResponse.data.rows);
        } catch (error) {
            console.error(`Error deleting state with ID ${zone_id}:`, error);
            Swal.fire("Error", "Failed to delete State!","error");


            console.error(error.response);
            console.error(error.message);
        }
    }
};
export default StatesList;
